<div class="select fl-w-auto" [class.select__focus]="selectOpened" [class.select__valued]="selectValue?.length > 0" [class.select_type_error]="hasError">
  <label class="select__label">{{ 'edit-group-modal.contacts-list' | translate }}</label>
  <div class="select__trigger-container" #selectTrigger (click)="selectOpened = !selectOpened">
    <div class="select__trigger with-icon" [innerHtml]="selectValue"></div>
    <div class="select__placeholder">{{ 'edit-group-modal.select-contacts' | translate }}</div>
  </div>
  <div class="select__dropdown" #selectDropdown>
    <div class="select__option" *ngFor="let contact of contacts" (click)="toggleItem(contact)" [class.select__option-active]="contact.selected">
      <div class="select__name">{{ contact.title }}</div>
      <div class="select__subtext">{{ contact.msisdn | mask: '+0 000 000-00-00' }}</div>
    </div>
  </div>
</div>
